module.exports = __webpack_public_path__ + "static/media/savestfundfrombank.264c333d.svg";